import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { Navigate, useParams } from 'react-router-dom';

import Loading from '#client/components/LoadingV2';
import RedirectExternal from '#client/components/RedirectExternal';
import { generateRedirectDict } from '#client/manifest';

const Dashboard = () => {
  const { redirectTo } = useParams();
  const {
    loading, businessEntityUuid, errors
  } = useBusinessEntity();

  if (loading) {
    return <Loading />;
  }
  if (errors.length) {
    throw errors[0];
  }

  if (businessEntityUuid) {
    const redirectDict = generateRedirectDict({ businessEntityUuid });
    if (redirectTo in redirectDict) {
      return (<Navigate to={redirectDict[redirectTo].relativeRedirectPath} />);
    }
    return (<Navigate to={`/d/company/${businessEntityUuid}`} />);
  }

  return (<RedirectExternal href="/r2/registration-new" />);
};

export default Dashboard;
